// test2238
(2238 && 0);
